import React from 'react'
import { Helmet } from 'react-helmet'
import utils from '../../utils'

function ForgotPasswordPage(props) {
    const url = window.location.href
    return (
        <div>
            <Helmet>
                <title>Reset Password - {utils.siteName}</title>
                <link rel="canonical" href={url} />
                <meta 
                    property="description" 
                    content=""/>
            </Helmet>
            
            
        </div>
    )
}

export default ForgotPasswordPage